export default __webpack_public_path__ + "static/media/white-check.23d50f1d.svg";